// Types
import { EquipmentUnitDataConeCrusher } from '../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../types/global';

export enum MaintenanceType {
  comboUnit = 'comboUnit',
  cone = 'cone',
  ifm = 'ifm',
  maintenance = 'maintenance',
  plc = 'plc',
  sensorScaling = 'sensorScaling',
  setPoint = 'setPoint',
  setup = 'setup',
}

export interface MaintenanceProps {
  className?: string;
  onChangeView: (view: MaintenanceType) => void;
  onClose: () => void;
  unitData: EquipmentUnitDataConeCrusher | null;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  showView: MaintenanceType;
  testId?: string;
}
